"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileTabLayout = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Colors_1 = require("../../../Colors");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const common_1 = require("../../../common");
const MobilePageTab_1 = require("./MobileLayout_Child/MobilePageTab");
const MobileTabLayoutStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	gap: 12px;
	align-items: flex-start;
	justify-content: flex-start;
	flex-shrink: 0;
	position: relative;
	width: 100%;
	height: 100%;

	.hr {
		background: var(--color-silver, #f3f4f8);
		flex-shrink: 0;
		width: 100%;
		height: 1px;
		position: relative;
	}

	.tab-navigation {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		//flex: 1;
		position: relative;
		width: 100%;

		.tab-left {
			color: var(--color-grey-w, #b6bac0);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 14px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;
			display: flex;
			flex-direction: row;
			gap: 4px;

			p {
				min-width: auto;
			}
		}

		.exit-regist {
			.overText {
				color: var(--color-black, #101010);
				text-align: left;
				font-family: 'Noto Sans KR', sans-serif;
				font-size: 14px;
				line-height: 150%;
				letter-spacing: -0.02em;
				font-weight: 700;
				position: relative;
			}
		}
	}
	.tab-item {
		width: 100%;
		flex: 1;
	}
	.assignment-page {
		justify-content: center;

		.button {
			width: 100%;
		}
	}

	.scroll-content {
		overflow: auto;
		display: flex;
		flex-direction: column;
		gap: ${props => (props.$isMobile ? 'unset' : '14px')};
		justify-content: flex-start;
	}

	.mobile-btn-wrap {
		.hr {
			margin-top: 14px;
		}
	}
`;
exports.MobileTabLayout = react_1.default.memo(({ isTabMode = false, tabList, footer, hideHr = false, previousPageList, submitAssignment, mobilePage, isSubmit, test_id, showPageButton = false, showNav = true, showPageTab = false, setMobilePage, handlerPreviousPage, cancelPopup, isPopup = false, }) => {
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [activeTabIndex, setActiveTabIndex] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        mobilePage && activeTabIndex !== mobilePage && setActiveTabIndex(mobilePage);
    }, [mobilePage]);
    (0, react_1.useEffect)(() => {
        setMobilePage && setMobilePage(activeTabIndex);
    }, [activeTabIndex]);
    const registNext = (index) => submitAssignment(index);
    const previousPage = () => {
        handlerPreviousPage
            ? handlerPreviousPage()
            : isMobile && tabList[activeTabIndex]?.isDetail
                ? previousPageList.setMember(undefined)
                : APP.eventManager.publish('UPDATE_DETAIL_MENU', {
                    menuDetail: previousPageList ? previousPageList.menuDetail : undefined,
                    id: test_id ? test_id : undefined,
                    mobilePage: previousPageList?.props?.mobilePage,
                    props: previousPageList?.props ? previousPageList.props : undefined,
                });
    };
    const renderButton = (0, react_1.useMemo)(() => showPageButton && (react_1.default.createElement("div", { className: "mobile-btn-wrap", style: isPopup ? { bottom: 0 } : undefined },
        !showPageTab && react_1.default.createElement("div", { className: "hr" }),
        react_1.default.createElement("div", { className: "btn-container assignment-page", style: { width: '100%', paddingTop: '12px' } },
            activeTabIndex === 0 ? (react_1.default.createElement(common_1.Button, { text: "common.cancel", className: "btn_white mobile-xs", onClick: () => cancelPopup ? cancelPopup() : previousPage() })) : (react_1.default.createElement(common_1.Button, { text: "assignment.previous", className: "btn_white mobile-xs", onClick: () => setActiveTabIndex(activeTabIndex - 1) })),
            tabList.length === activeTabIndex + 1 ? (react_1.default.createElement(common_1.Button, { text: "common.okay", className: "btn_default mobile-xs", onClick: () => submitAssignment(undefined) })) : (react_1.default.createElement(common_1.Button, { text: "assignment.next", className: "btn_default mobile-xs", onClick: () => isSubmit
                    ? registNext(activeTabIndex)
                    : setActiveTabIndex(activeTabIndex + 1) }))))), [tabList, showPageButton, previousPageList, activeTabIndex, submitAssignment, cancelPopup]);
    const renderPageContent = (0, react_1.useMemo)(() => showPageTab ? (react_1.default.createElement(react_1.default.Fragment, null,
        footer,
        react_1.default.createElement("div", { key: isSubmit ? test_id : tabList[activeTabIndex]?.id || 1, className: "tab-item", style: tabList[activeTabIndex]?.styles }, tabList[activeTabIndex] && tabList[activeTabIndex].component),
        !showPageTab && renderButton)) : (react_1.default.createElement("div", { className: "scroll-content" },
        footer,
        react_1.default.createElement("div", { key: isSubmit ? test_id : tabList[activeTabIndex].id, className: "tab-item", style: tabList[activeTabIndex]?.styles }, tabList[activeTabIndex] && tabList[activeTabIndex].component),
        !showPageTab && renderButton)), [activeTabIndex, tabList, isSubmit, test_id, footer]);
    return (react_1.default.createElement(MobileTabLayoutStyled, { "$isMobile": isMobile, className: "mobile-tab-layout", style: { gap: showPageButton && '12px' } },
        showNav ? (react_1.default.createElement(react_1.default.Fragment, null,
            (previousPageList ||
                tabList[activeTabIndex - 1] ||
                tabList[activeTabIndex + 1]) && (react_1.default.createElement("div", { className: "tab-navigation" }, previousPageList ? (react_1.default.createElement(common_1.Button, { className: "exit-regist", text: previousPageList.title, onClick: previousPage, option: {
                    buttonBeforeIcon: {
                        show: true,
                        name: 'arrow',
                        size: 24,
                        color: Colors_1.Colors.w_grey,
                    },
                } })) : (react_1.default.createElement(react_1.default.Fragment, null,
                tabList[activeTabIndex - 1] && (react_1.default.createElement(common_1.Button, { className: "tab-left", text: tabList[activeTabIndex - 1].title, onClick: () => setActiveTabIndex(activeTabIndex - 1), option: {
                        buttonBeforeIcon: {
                            show: true,
                            name: 'arrow',
                            size: 18,
                            color: Colors_1.Colors.w_grey,
                        },
                    } })),
                tabList[activeTabIndex + 1] && (react_1.default.createElement(common_1.Button, { className: "tab-right", text: tabList[activeTabIndex + 1].title, onClick: () => setActiveTabIndex(activeTabIndex + 1), option: {
                        buttonAfterIcon: {
                            show: true,
                            className: 'arrow-right',
                            name: 'arrow',
                            size: 18,
                            color: Colors_1.Colors.w_grey,
                        },
                    } })))))),
            !hideHr && react_1.default.createElement("div", { className: "hr" }))) : showPageTab ? (react_1.default.createElement(MobilePageTab_1.MobilePageTab, { isTabMode: isTabMode, activeTabIndex: activeTabIndex, tabList: tabList, previousPage: previousPage, content: renderPageContent, button: renderButton, setActiveTabIndex: setActiveTabIndex, isPopup: isPopup })) : (react_1.default.createElement(react_1.default.Fragment, null)),
        !showPageTab && renderPageContent));
});
